module.exports = __webpack_public_path__ + "images/villablanca.25bf5831fb69f1f0b0c9efb374e716ad.png";